/** Page size for wins list (used by WinsBlock server fetch and WinsProvider client logic). */
export const WINS_PER_PAGE = 8
